export default __webpack_public_path__ + "static/media/white-star.87d8bd95718a0edc2879abd56dcf3424.svg";